import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { getNextShow, formatCountdown, formatLocalTime } from "@/lib/schedule";

export default function NextShowBanner() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(t);
  }, []);

  const next = getNextShow(now);
  if (!next) return null;

  const localStr = formatLocalTime(next.when);
  const countdown = formatCountdown(next.when, now);

  return (
    <div
      data-testid="next-show-banner"
      className="mb-6 inline-flex items-center gap-3 px-5 py-3 rounded-full bg-[#2A2E2C] text-white shadow-md"
    >
      <span className="w-7 h-7 rounded-full bg-[#DDA754] text-[#2A2E2C] flex items-center justify-center">
        <Sparkles className="w-3.5 h-3.5" />
      </span>
      <div className="flex flex-wrap items-baseline gap-x-3 gap-y-0">
        <span className="ccn-overline text-[#DDA754]">Next up</span>
        <span className="font-heading text-lg leading-tight">{next.label}</span>
        <span className="text-sm text-white/70">· {next.ctTime}</span>
        <span className="text-sm text-white/90">· <span className="text-[#DDA754] font-medium">{localStr}</span> your time</span>
        <span className="text-sm text-white/90">· starts in <span className="font-medium">{countdown}</span></span>
      </div>
    </div>
  );
}
